import React  from "react";
import {Flex, Grid, GridItem, VStack} from "@chakra-ui/react";
import { AuthenticatedLayout } from "layouts";
import { Card, MiniCalendar } from "components";
import UpcomingSessions from "./UpcomingSessions";
import PastSessions from "./PastSessions";
import { useUser } from "context/user";
import { UserRole } from "types/user";

const Dashboard: React.FC = () => {
  const { user } = useUser()!;

  return (
    <AuthenticatedLayout>
      <Grid
        gap={8}
        gridTemplateColumns={{
          base: "1fr",
          lg: "repeat(3, auto)"
        }}
        gridTemplateRows={{
          base: "repeat(4, auto)",
          lg: "repeat(2, auto)"
        }}
        templateAreas={{
          base: "'sessions' 'calendar' 'time' 'progress'",
          lg: `
          'sessions sessions calendar'
          'time progress progress'
        `
        }}
      >
        <GridItem gridArea="sessions">
          <VStack alignItems="flex-start" spacing={8}>
            <UpcomingSessions/>
            <PastSessions/>
          </VStack>
        </GridItem>
        <Flex gridArea="calendar">
          <Card height="fit-content" width="100%">
            <MiniCalendar/>
          </Card>
        </Flex>
      </Grid>
    </AuthenticatedLayout>
  );
};

export default Dashboard;
